import { render, staticRenderFns } from "./DoctorCardAppointment.vue?vue&type=template&id=2aa3174d&"
import script from "./DoctorCardAppointment.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorCardAppointment.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa3174d')) {
      api.createRecord('2aa3174d', component.options)
    } else {
      api.reload('2aa3174d', component.options)
    }
    module.hot.accept("./DoctorCardAppointment.vue?vue&type=template&id=2aa3174d&", function () {
      api.rerender('2aa3174d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorCardAppointment.vue"
export default component.exports